import TourConfigBreadcrumbs from '@/features/dashboard/tourConfig/components/TourConfigBreadcrumbs.tsx';
import TourConfigHeader from '@/features/dashboard/tourConfig/components/TourConfigHeader.tsx';
import React from 'react';
import TourOptionsConfigCard from '@/features/dashboard/tourOptions/components/TourOptionsConfigCard.tsx';
import { useNavigate } from '@tanstack/react-router';
import { tourOptionsConfigRoute } from '@/features/dashboard/tourOptions/routes/tourOptionsConfigRoute.ts';

const TourOptionsConfigPage = () => {
  const { tourId } = tourOptionsConfigRoute.useParams();
  const navigate = useNavigate();

  const onNext = async () => {
    navigate({
      to: `/app/tours/${tourId}/config/installments/`,
    });
  };

  return (
    <div className="space-y-4">
      <TourConfigBreadcrumbs />
      <div className="flex-1 space-y-4"></div>
      <TourConfigHeader
        title="Opcje dodatkowe"
        isLoading={false}
        submit={onNext}
      />
      <div className="mx-auto max-w-[700px] space-y-2">
        <TourOptionsConfigCard />
      </div>
    </div>
  );
};

export default TourOptionsConfigPage;
